import React from 'react';
import { PLANS } from '../data/content';
import Icon from './Icon';
import './PlansSection.css';

export default function PlansSection() {
  const scrollToQuote = () =>
    document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="section plans-section" id="plans">
      <div className="sec-in">
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div className="eyebrow">Coverage Plans</div>
          <div className="sec-title" style={{ marginBottom: 12 }}>Choose your coverage level</div>
          <p style={{ fontSize: 15, color: 'var(--g600)', maxWidth: 520, margin: '0 auto' }}>
            Tell us what matters most to you. Our advisors will match you with the right plan and pricing for your home.
          </p>
        </div>

        <div className="plan-cards">
          {PLANS.map((p) => (
            <div key={p.name} className={`pc ${p.popular ? 'pop' : ''}`}>
              {p.popular && <div className="pc-badge">Most Popular</div>}
              <div className="pc-name">{p.name}</div>
              <p className="pc-desc">{p.desc}</p>
              <div className="pc-div" />
              <ul className="pc-list">
                {p.features.map((f) => (
                  <li key={f.text}>
                    <span className={f.included ? 'ck' : 'cx'}>
                      <Icon name={f.included ? 'Check' : 'X'} size={14} strokeWidth={2.5} />
                    </span>
                    <span style={{ color: f.included ? 'inherit' : 'var(--g400)' }}>
                      {f.text}
                    </span>
                  </li>
                ))}
              </ul>
              <button
                className={`pc-btn ${p.popular ? 'primary' : 'ghost'}`}
                onClick={scrollToQuote}
              >
                Get {p.name} Quote
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
